import { motion } from 'framer-motion';
import { useKotchTheme } from './KotchThemeContext';

export default function ThemeToggle() {
  const { theme, toggleTheme } = useKotchTheme();

  return (
    <button
      className="kotch-theme-toggle"
      onClick={toggleTheme}
      title={theme === 'elegant' ? 'Switch to Tavern theme' : 'Switch to Elegant theme'}
    >
      <div className="theme-toggle-track">
        <motion.div
          className="theme-toggle-thumb"
          animate={{ x: theme === 'tavern' ? 24 : 0 }}
          transition={{ type: 'spring', stiffness: 500, damping: 30 }}
        />
        <span className="theme-toggle-icon theme-toggle-elegant">
          ◇
        </span>
        <span className="theme-toggle-icon theme-toggle-tavern">
          ⚔
        </span>
      </div>
      <span className="theme-toggle-label">
        {theme === 'elegant' ? 'Elegant' : 'Tavern'}
      </span>
    </button>
  );
}
